import React from "react";
import { Modal, ScrollArea, Title, TextInput, Grid, Select, NumberInput, Button } from "@mantine/core";

interface TrainerFormModalProps {
    opened: boolean;
    onClose: () => void;
    editingTrainerId: string | null;
    form: any;
    branchList: any[];
    handleSaveTrainer: () => void;
    savebtnLoader: boolean;
}

export default function TrainerFormModal({
    opened,
    onClose,
    editingTrainerId,
    form,
    branchList,
    handleSaveTrainer,
    savebtnLoader
}: TrainerFormModalProps) {
    return (
        <Modal
            scrollAreaComponent={ScrollArea.Autosize}
            opened={opened}
            onClose={onClose}
            title={<Title order={4}>{editingTrainerId ? "Edit Trainer" : "Add New Trainer"}</Title>}
            closeButtonProps={{ iconSize: "52" }}
            radius="md"
        >
            <TextInput
                label="First Name"
                required
                style={{ marginBottom: "16px" }}
                {...form.getInputProps("first_name")}
            />
            <TextInput
                label="Last Name"
                required
                style={{ marginBottom: "16px" }}
                {...form.getInputProps("last_name")}
            />
            <TextInput
                label="Email"
                required
                style={{ marginBottom: "16px" }}
                {...form.getInputProps("email")}
            />
            <TextInput
                label="Phone Number"
                placeholder="e.g. 9999999999"
                required
                withAsterisk
                style={{ marginBottom: "16px" }}
                type="number"
                maxLength={10}
                onInput={(e: any) => (e.currentTarget.value = e.currentTarget.value.slice(0, 10))}
                {...form.getInputProps("mobile_number")}
            />
            <TextInput
                label="Designation"
                placeholder="e.g. Certified Head Trainer"
                style={{ marginBottom: "16px" }}
                {...form.getInputProps("designation")}
            />

            <Grid style={{ marginBottom: "16px" }}>
                <Grid.Col span={6}>
                    <Select
                        label="Wage Contract"
                        data={[
                            { label: "Fixed Rate", value: "fixed" },
                            { label: "Per Head", value: "per_head" }
                        ]}
                        {...form.getInputProps("wage_type")}
                    />
                </Grid.Col>
                <Grid.Col span={6}>
                    <NumberInput
                        label="Rate per session (₹)"
                        min={0}
                        {...form.getInputProps("wage_amount")}
                    />
                </Grid.Col>
            </Grid>

            <Select
                style={{ marginBottom: "16px" }}
                placeholder="Select Type"
                data={[{ value: "trainer", label: "Trainer" }]}
                label="Select Type"
                disabled
                {...form.getInputProps("type")}
            />

            <Select
                style={{ marginBottom: "24px" }}
                label="Select Branch"
                placeholder="Select Branch"
                maxDropdownHeight={200}
                data={branchList
                    .filter((item: any) => item.id !== "all" && item.id !== "all_branches" && item.name !== "All Branch" && item.name !== "All Branches")
                    .map((item: any) => ({
                    value: item.id,
                    label: item.name || item.branch_name || "Unknown Branch",
                }))}
                {...form.getInputProps("branch_id")}
            />

            <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
                <Button onClick={onClose} variant="outline" color="gray">
                    Cancel
                </Button>
                <Button onClick={handleSaveTrainer} loading={savebtnLoader} style={{ backgroundColor: "#ee374d" }}>
                    Save
                </Button>
            </div>
        </Modal>
    );
}
